import { render, staticRenderFns } from "./SharedStarsItem.vue?vue&type=template&id=e7771348&"
import script from "./SharedStarsItem.vue?vue&type=script&lang=js&"
export * from "./SharedStarsItem.vue?vue&type=script&lang=js&"
import style0 from "./SharedStarsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports